import { render } from "./SendMail.vue?vue&type=template&id=71de88c8&scoped=true"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"

import "./SendMail.vue?vue&type=style&index=0&id=71de88c8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Cesar\\Documents\\Proyectos\\POSVitialife\\FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71de88c8"]])

export default __exports__